import Cookies from 'js-cookie'

const TokenKey = 'Admin-CoCo-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getItem(lName) {
  if (lName === 'userInfo') {
    return JSON.parse(localStorage.getItem(lName));
  } else {
    return localStorage.getItem(lName);
  }
}

export function setItem(lName, vo) {
  if (typeof vo === 'string') {
    return localStorage.setItem(lName, vo);
  } else {
    return localStorage.setItem(lName, JSON.stringify(vo));
  }
}

export function removeItem(lName) {
  return localStorage.removeItem(lName);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js